import { useState, useEffect, useMemo, useRef } from "react";
import { useQuery } from "@apollo/client";
import { GET_ACTIVE_USER } from "../../../../queries/auth.queries";
import { GET_ACTIVE_ORDER } from "../../../../queries/cart.queries";

export function useShippingAddresses() {
  const { data: userData, loading: userLoading } = useQuery(GET_ACTIVE_USER);
  const { data: orderData, loading: orderLoading } = useQuery(GET_ACTIVE_ORDER);

  const addresses = useMemo(
    () => userData?.activeCustomer?.addresses ?? [],
    [userData]
  );

  const currentOrderAddress = orderData?.activeOrder?.shippingAddress ?? null;

  const [selected, setSelected] = useState(null);

  // NEW FLAG TO PREVENT RESETTING SELECTION
  const hasUserSelected = useRef(false);

  // Wrap setSelected to mark manual selection
  const handleSelect = (address: any) => {
    hasUserSelected.current = true;
    setSelected(address);
  };

  // Auto-preselect only ONCE (first load)
  useEffect(() => {
    if (!addresses.length) return;
    if (hasUserSelected.current) return; // <-- Prevent overwriting user's choice

    let preselect = null;

    if (currentOrderAddress) {
      const { latitude, longitude } = currentOrderAddress;
      preselect = addresses.find(
        (addr: any) =>
          addr.latitude === latitude && addr.longitude === longitude
      );
    }

    if (!preselect) {
      preselect = addresses.find((a: any) => a.defaultShippingAddress);
    }

    if (preselect) {
      setSelected(preselect);
    }
  }, [addresses, currentOrderAddress]);

  return {
    addresses,
    currentOrderAddress,
    selected,
    setSelected: handleSelect, // return the wrapped setter
    loading: userLoading || orderLoading,
  };
}
